































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ComponentsPartsCatalogCardComponentsTabsTeachers extends Vue {
  // Props
  @Prop({ type: Array, default: [] })
  list: Array<any>;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/card/components/tabs/teachers/Teachers.vue